import { render, staticRenderFns } from "./PartnersJoin.vue?vue&type=template&id=ce2a1f44&scoped=true"
import script from "./PartnersJoin.vue?vue&type=script&lang=js"
export * from "./PartnersJoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2a1f44",
  null
  
)

export default component.exports